import React from 'react'

import Decklist from 'components/decklists/DeckListWithMetaData'

export const WinnerTwo: React.FC = () => {
  return (
    <Decklist
      name="Another Vertex Winner"
      drafter="Kerby"
      description={
        <>
          Blue really was the best color back then, if this deck is any
          evidence. Also loving the single-card Red splash. Fetch Words of War
          with Zur?!?!
        </>
      }
      maindeck={[
        [
          { name: 'Tolaria West', set: 'FUT' },
          { name: 'Stone Quarry', set: 'SOI' },
          { name: 'Plains', set: 'TSP' },
          { name: 'Moonring Island' },
          { name: 'Tournament Grounds' },
          { name: 'Temple of Deceit', set: 'THS' },
          { name: 'Dark Depths', set: 'CSP' },
          { name: 'Snow-Covered Island', set: 'CSP' },
          { name: 'Kabira Crossroads', set: 'ZEN' },
          { name: 'Leechridden Swamp', set: 'SHM' },
          { name: 'Arcane Sanctum', set: 'ALA' },
          { name: 'Flagstones of Trokair', set: 'TSP' },
          { name: 'Temple of Triumph', set: 'THS' },
          { name: 'Drownyard Temple', set: 'SOI' },
          { name: 'Frost Marsh', set: 'CSP' },
          { name: 'Orzhov Basilica', set: 'GPT' },
          { name: 'Memorial to Genius' },
        ],
        [
          { name: 'Birds of Paradise', set: 'RAV' },
          { name: 'Ancestral Vision', set: 'TSR' },
          { name: 'Profane Tutor', set: 'MH2' },
        ],
        [
          { name: 'Delay', set: 'FUT' },
          { name: 'Vampire Hexmage', set: 'ZEN' },
        ],
        [
          { name: 'Haakon, Stromgald Scourge', set: 'CSP' },
          { name: 'Rend Flesh', set: 'CHK' },
          { name: 'Words of War', set: 'ONS' },
          { name: 'Mirror Entity', set: 'TSR' },
          { name: 'Curse of the Bloody Tome', set: 'ISD' },
          { name: 'As Foretold', set: 'AKH' },
        ],
        [
          { name: 'Mystical Teachings', set: 'TSP' },
          { name: 'Trading Post', set: 'M13' },
          { name: 'Zur the Enchanter', set: 'CSP' },
        ],
        [
          { name: 'Meloku the Clouded Mirror', set: 'CHK' },
          { name: 'Archon of Justice', set: 'M12' },
          { name: 'Exile Into Darkness' },
          { name: 'Shadow of the Second Sun' },
          { name: 'Austere Command', set: 'LRW' },
          { name: 'Deny Reality', set: 'ARB' },
          { name: 'Triskelion', set: 'MRD' },
          { name: 'Obzedat, Ghost Council', set: 'GTC' },
        ],
      ]}
    />
  )
}
